import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Graphic, GraphicDataAttr } from './Graphic';

export class GraphicMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects: ObjectManager;

    public start() {
        this.burden(
            this.objects.on('Graphic', 'affected', ([x]) => this.sync(x.as(Graphic))),
            this.objects.on('Graphic', 'allocated', ([x]) => this.sync(x.as(Graphic))),
        );

        this.syncAll();
    }

    private syncAll = () => {
        for (const g of this.objects.getAll(Graphic)) {
            this.sync(g);
        }
    };

    private sync = (graphic: Graphic) => {
        if (!graphic) return;

        const data = GraphicDataAttr.get(graphic);
        if ((graphic.url || '') !== (data?.url || '')) {
            GraphicDataAttr.set(graphic, { url: graphic.url, img: null });
            this.loadDataFor(graphic);
        }
        else if (!graphic.url && !!data) {
            GraphicDataAttr.set(graphic, null);
        }
    };

    private loadDataFor = (graphic: Graphic) => {
        const { url } = graphic;
        if (!url) return;

        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
            if (this.destroyed()) return;
            if (!graphic?.alive) return;
            GraphicDataAttr.set(graphic, { url, img });
        };
        img.onerror = () => {
            console.error('Error loading graphic:', url);
        };
    };
}
